import { LOGIN, LOGIN_ERROR, LOGIN_GOOGLE_URL, LOGOUT, LOGIN_SOCIAL } from "./constants";

export function login(credential, cbSuccess, navigate){
    return {
        type: LOGIN,
        credential,
        cbSuccess,
        navigate,
    }
}
export function loginSocial(social, auth, cbSuccess){
    return {
        type: LOGIN_SOCIAL,
        social,
        auth,
        cbSuccess,
    }
}
export function logout(cbSuccess, action, refreshToken){
    return {
        type: LOGOUT,
        cbSuccess,
        action,
        refreshToken
    }
}

export function setLoginError(loginError){
    return{
        type: LOGIN_ERROR,
        loginError,
    }
}
export function getGoogleAuthUrl(cbSuccess){
    return{
        type: LOGIN_GOOGLE_URL,
        cbSuccess
    }
}